import { render, staticRenderFns } from "./PatientHistoryItemDocuments.vue?vue&type=template&id=3391cb2e&scoped=true&lang=pug&"
import script from "./PatientHistoryItemDocuments.vue?vue&type=script&lang=js&"
export * from "./PatientHistoryItemDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3391cb2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
